import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectClassicRoute: InvariantJiraRoute = {
	name: 'issue-navigator-classic',
	// Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
	path: '/jira/software/c/projects/:projectKey/issues/:issueKey?',
	query: ['selectedIssue?'],
};
